var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"expo-btn expo-btn-red m-0",attrs:{"title":_vm.$t('general.logout')},on:{"click":_vm.handleLogOut}},[_c('b-icon-box-arrow-right')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }